import apiRequest from './apiRequest';

export default async function getUserApiKey() {
  return apiRequest<{ apiKey: string; serviceID: string }>(
    'user',
    '/users/apiKey',
  );
}
